import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Checkbox as RsuitCheckbox } from "rsuite";
import { CheckPicker, IconButton } from "rsuite";
import SpinnerIcon from "@rsuite/icons/legacy/Spinner";

function CheckFilter({
  data, // userName
  value, // accountOwner
  setValue, // setAccountOwner
  isFilter, //  isFilterAccountOwner
  setIsFilter, // setIsFilterAccountOwner
  handlePopOverClose, // handlePopOverClose
  setActiveField, //setActiveField
  field, // filedName
  filterData, // filterData
  placeholder, // placeholder
  fetchData, // api data
  page,
  rowsPerPage,
  setSearchKeyword,
  searchKeyword,
  debouncingFunction
}) {
  const [selectedValue, setSelectedValue] = React.useState(value);
  const [dataManage,setDataManage]=useState([]);
  const debounceTimer = React.useRef(null);
  const [checked,setChecked]=useState([]);

  const renderMenu = (menu, data) => {
    if (data.length === 0) {
      return (
        <p style={{ padding: 4, color: "#999", textAlign: "center" }}>
          <SpinnerIcon spin /> loading...
        </p>
      );
    }
    return menu;
  };

  const toSetFilter = () => {
    setValue(selectedValue);
    setActiveField({
      name: field,
      value: selectedValue,
    });
    setIsFilter(true);
     if (page && rowsPerPage) {
      filterData(0, rowsPerPage, field, selectedValue);
    } else {
      filterData(selectedValue, field);
    }
  };

    

  const handleSearch = (searchValue) => {
    setSearchKeyword && setSearchKeyword(searchValue);
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    if (searchValue.length >= 3) {
      debounceTimer.current = setTimeout(() => {
       debouncingFunction && debouncingFunction(searchValue);
      }, 1000); // 1 second pause
    }
  };

  useEffect(() => {
   
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);
  useEffect(() => {
    let arr = selectedValue?.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
   debouncingFunction && setDataManage([...checked,...arr,...data]);
  }, [data,checked]);

const removeDuplicate = (arr) => {
    const seen = new Map();
    
    arr.forEach(item => {
        if (!seen.has(item.label)) {
            seen.set(item.label, item);
        }
    });
    
    return Array.from(seen.values());
};
  return (
    <div>
      <Box sx={{ display: "flex", gap: 5 }}>
        <CheckPicker
          data={dataManage.length > 0 ? removeDuplicate(dataManage) : data}
          style={{ width: 224 }}
          renderMenu={(menu) => renderMenu(menu, data)}
          menuClassName="reactMultiSelectMenu"
          value={selectedValue}
          onChange={(selectedOption) => {
            let arr = selectedOption?.map((item) => {
              return {
                label: item,
                value: item,
              };
            });
            setChecked(arr);
            setSelectedValue(selectedOption);
          }}
          onSearch={handleSearch}
          onClean={() => {
            setValue([]);
            setSelectedValue([]);
            setSearchKeyword && setSearchKeyword("");
            setActiveField({
              name: "",
              value: "",
            });
            if (isFilter) {
              setIsFilter(false);
              handlePopOverClose(false);
              if (page && rowsPerPage) {
                filterData(0, rowsPerPage, field, "");
              } else {
                filterData("", field);
              }
            }
          }}
          onOpen={fetchData ? fetchData : () => {}}
          renderExtraFooter={() => (
            <div
              style={{
                padding: "7px 2px 0px",
                borderTop: "1px solid #e5e5e5",
              }}
            >
              <RsuitCheckbox
                indeterminate={
                  selectedValue.length > 0 && selectedValue.length < data.length
                }
                checked={selectedValue.length === data.length}
                onChange={(e, checked) => {
                  setSelectedValue(
                    checked ? data.map((user) => user?.value) : []
                  );
                }}
              >
                Check all
              </RsuitCheckbox>
            </div>
          )}
          placeholder={placeholder}
        />
        <IconButton
          color={"#fff"}
          background={"var(--main-bg-color)"}
          aria-label="Search date range"
          _hover={{
            background: "var(--main-bg-color)",
          }}
          size={"sm"}
          disabled={!selectedValue?.length}
          icon={<FiSearch />}
          onClick={toSetFilter}
        />
      </Box>
    </div>
  );
}

export default CheckFilter;